import styles from "./MeetingInformationSlider.module.css";
import classNames from "classnames";
import PropTypes from "prop-types";

import MeetingInformationItem from "../../Shared/MeetingInformationItem";
import arrow from "./arrow2.png";
import { useState } from "react";

/**
 *
 *A slider of all upcoming meetings starting with the next upcoming meeting. Each slide provides all of the necessary information for each meeting. User clicks on left and right arrows to change slides.
 *
 */

export function MeetingInformationSlider({ meetings, onClick, onArrowClick }) {
  const [meetingIndex, setMeetingIndex] = useState(0);
  return (
    <div className={styles.container}>
      <div>
        {meetingIndex > 0 && (
          <img
            src={arrow}
            className={classNames(styles.imageFlip)}
            onClick={() => {
              setMeetingIndex((meetingIndex) => meetingIndex - 1);
              onArrowClick(-1);
            }}
            alt=""
          />
        )}
      </div>

      <MeetingInformationItem
        years={meetings[meetingIndex].years}
        months={meetings[meetingIndex].months}
        days={meetings[meetingIndex].days}
        location={meetings[meetingIndex].location}
        state={meetings[meetingIndex].state}
        city={meetings[meetingIndex].city}
        time={meetings[meetingIndex].time}
        isInPerson={meetings[meetingIndex].isInPerson}
        isVirtual={meetings[meetingIndex].isVirtual}
        isTextLight={meetings[meetingIndex].isTextLight}
        onClick={onClick}
      />

      <div>
        {meetingIndex < meetings.length - 1 && (
          <img
            src={arrow}
            className={classNames(styles.image)}
            onClick={() => {
              setMeetingIndex((meetingIndex) => meetingIndex + 1);
              onArrowClick(1);
            }}
            alt=""
          />
        )}
      </div>
    </div>
  );
}

MeetingInformationSlider.propTypes = {
  meetings: PropTypes.array,
  onClick: PropTypes.func,
};
